import type { FunctionMachineWidgetConfig } from '../function-machine.widget';

export const FUNCTION_MACHINE_DEFAULT_PRESET: FunctionMachineWidgetConfig = {
  id: 'function-machine-default',
  type: 'function-machine',
  params: {
    blocks: [
      { type: 'value', id: 'input', value: 3 },
      { type: 'function', id: 'f', expression: '2*x+1', variable: 'x', color: 'sky', name: 'f' },
      { type: 'value', id: 'output' },
    ],
  },
  display: {
    layout: 'horizontal',
    showRunButton: true,
  },
};
